module.exports = __webpack_public_path__ + "static/media/leaf-bg.466f76ed.svg";